import getThdLoginUrl from '../../helpers/getThdLoginUrl';

export default (returnUrl = null) => {
  window.location.href = getThdLoginUrl(returnUrl || window.location.href);
};
